const initialState = {
  error : ''
}

export default function (state = initialState, {type, payload}) {
  switch (type) {
    case 'SHOW_ERROR': state = { ...state, error: payload } 
    break
    case 'HIDE_ERROR': state = { ...state, error: payload }
    break
  }
  return state
}



// WEBPACK FOOTER //
// ./src/appReducer.js